//frontend/src/components/OrdersPage/OrderFinances/OrderFinanceProofUpload.jsx

import React, { useState } from "react";
import { authFetch } from "../../api/api";

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

export default function OrderFinanceProofUpload({
  financeId,
  type,
  onUploaded,
}) {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");

  const handleFilesChange = (e) => {
    setFiles(Array.from(e.target.files));
  };

  const upload = async () => {
    if (!files.length) return;

    setLoading(true);

    try {
      const fd = new FormData();

      fd.append("type", type);
      fd.append("comment", comment);

      files.forEach((file) => {
        fd.append("images", file);
      });

      const res = await authFetch(
        `${BASE_URL}/api/order-finances/${financeId}/upload_proof/`,
        {
          method: "POST",
          body: fd,
        }
      );

      if (!res.ok) {
        throw new Error("Upload failed");
      }

      const data = await res.json();

      setFiles([]);
      setComment(""); 

      // вернуть новые proof’ы в родителя
      if (onUploaded) {
        onUploaded(data);
      }
    } catch (err) {
      console.error(err);
      alert("Upload error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border p-3 rounded space-y-2">
      <div className="text-sm font-semibold">
        Upload proofs ({type})
      </div>

      <input
        type="file"
        multiple
        onChange={handleFilesChange}
      />

      <input
        type="text"
        placeholder="Comment"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        className="border p-1 text-sm w-full"
      />

      {files.length > 0 && (
        <div className="text-xs text-gray-600">
          {files.length} file(s) selected
        </div>
      )}

      <button
        onClick={upload}
        disabled={loading || !files.length}
        className="px-3 py-1 bg-blue-600 text-white text-sm rounded disabled:opacity-50"
      >
        {loading ? "Uploading..." : "Upload"}
      </button>
    </div>




  );
}